<template>
  <div
    :class="[
      'flex rounded-full w-fit bg-gray-900 bg-opacity-5 text-xs font-medium py-0 pl-1 pr-2 text-center items-center',
      containerClasses,
      'sm_text-sm',
      invertIconSet ? 'text-white' : 'text-gray-950',
    ]"
    data-testid="asset-tag-name"
  >
    <IconsSite v-if="tag === '360'" />
    <IconsThreeD v-else-if="tag === '3D'" />
    <CurrencyDollarIcon v-else-if="tag === 'Cash Flow Model'" class="w-6 p-1" />
    <p class="mb-0">{{ displayText }}</p>
  </div>
</template>

<script lang="ts" setup>
import { CurrencyDollarIcon } from '@heroicons/vue/24/outline'
import IconsSite from '@/components/icons/Site.svg'
import IconsThreeD from '@/components/icons/ThreeD.svg'

const props = defineProps({
  tag: {
    type: String,
    required: true,
  },
  containerClasses: {
    type: String,
    default: '',
  },
  invertIconSet: {
    type: Boolean,
    default: false,
  },
})

const displayText = computed(() => {
  switch (props.tag) {
    case 'Cash Flow Model':
      return 'Model'

    default:
      return props.tag
  }
})
</script>
